module.exports = __webpack_public_path__ + "static/media/icon-moon.37546a05.svg";